import {get, post} from "$lib/api";

export const getTimeLine = async (project:any) => {
    return await get('/timeline/' + project.uuid);
}
export const postTimeLine = async (project:any, data:any) => {
    return await post('/timeline/' + project.uuid, data);
}
export const createInfo = async (project:any, title:string, description:string) => {
    return await post('/timeline/' + project.uuid, {
        title: title,
        description: description,
        type: 'info'
    });
}
export const timelineItemForFileUpload = async (project:any, fileName:string) => {
    return await post('/timeline/' + project.uuid, {
        title: 'Neue Datei hochgeladen',
        description: `Die Datei ${fileName} wurde hochgeladen.`,
        type: 'important'
    });
}